export class FgItemCreIdRequest {
fgItemId :number;
     constructor(fgItemId :number ) {
            this.fgItemId =fgItemId
        }
    }
    